import { Button, Typography } from "@material-ui/core";
import React, { useEffect, useReducer, useState } from "react";
import translate from "../../../i18n/translate";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import ErrorPage from "../../shared/ErrorPage/ErrorPage";
import Toaster from "../Toaster/Toaster";
import "./DailyNewsFeedComponent.scss";
import { useSelector } from "react-redux";

const DailyNewsFeedComponent = (props: any) => {

    const [isNewsfeedfeatureenabled, setnewsfeedfeatureenabled] = useState(false);
    let truncateLength = 60; // number of characters to show
    const allInfo = useSelector((state: any) => state);

    const [toastOptions, settoastOptions] = useReducer((state: any, newState: any) => ({ ...state, ...newState }), {
        toastOpen: false,
        toastSeverity: "error",
        toastMessageKey: "",
    });

    const handleToastOptionsDirect = (name: string, val: any) => {
        settoastOptions({ [name]: val });
    }

    const toasterHandle = (open: boolean, severity: string, messageKey: string) => {
        handleToastOptionsDirect("toastSeverity", severity);
        handleToastOptionsDirect("toastMessageKey", messageKey);
        handleToastOptionsDirect("toastOpen", !!open);
    };

    useEffect(() => {
        if (!!!allInfo.peopleInformation.isLoading && !!!allInfo.peopleInformation.isFailed && !!allInfo.peopleInformation.data) {
            if ((allInfo.peopleInformation.data.getpeopleInformation.serviceConfiguration.features.substring(46, 47)) === "1") {
                setnewsfeedfeatureenabled(true);
            }
        }
    }, [allInfo.peopleInformation]);

    const feed_Click = (UUID?: string, category?: string, portalurl?: string) => {
        if ((process.env["REACT_APP_NEWSFEEDREDIRECTURL"] || "").match(/.learnship./g)) {
            window.open(`${process.env["REACT_APP_NEWSFEEDREDIRECTURL"]}/${category ? category.toLowerCase() + "/" : ""}${UUID ? UUID : ""}`);
        } else {
            window.open(`${portalurl ? portalurl : props.portalLoginURL}&redirect=${process.env["REACT_APP_NEWSFEEDREDIRECTURL"]}/${category ? category.toLowerCase() + "/" : ""}${UUID ? UUID : ""}`);
        }
    }

    const truncateText = (fullTitleText: string) => {
        return (fullTitleText.length > truncateLength) ? `${fullTitleText.slice(0, truncateLength)}...` : fullTitleText;
    }

    return (
        <span>
            {(
                <span>
                    {isNewsfeedfeatureenabled && (
                        <div className="DailyNewsFeedContainer">
                            <Toaster
                                open={toastOptions.toastOpen}
                                severity={toastOptions.toastSeverity}
                                toasterClosed={toasterHandle}
                                messageKey={toastOptions.toastMessageKey}
                            />
                            <div className="FeedListalign PageFeedContainerBlock">
                                <div className="header_Text">
                                    <span></span> {translate("dailyNewsFeed_resources")}
                                </div>
                                <div className="dailynewsfeed-header">
                                    <div className="Feedheaderalign">
                                        <span>{translate("dailyNewsFeed_daily_News")}</span>
                                        <Button type="button" onClick={() => { feed_Click() }} className="vm-categories pull-right">{translate("dailyNewsFeed_viewMoreCategories")} <ArrowForwardIosIcon className="readmore-arrow" /></Button>
                                    </div>
                                </div>

                                <div className="newsFeedCardListContainer">
                                    {
                                        (props.data && props.data.length > 0) ?
                                            props.data.map((post: any) => {
                                                return (
                                                    <div className="border_Feed">
                                                        <div className="newsFeedCard" onClick={() => feed_Click(post["UUID"] || "", post["Category"] || "", post["portalurl"] || "")}>
                                                            <div className="newsFeedCard-body">
                                                                <div className="newsFeedCard-img"><img src={post["ImageUrl"] || "../../../images/NewsFeed/news-feed-noImage.jpg"} alt={post["Title"]||""} /></div>
                                                                <div className="newsFeedCard-title">{truncateText(post["Title"])}</div>
                                                                <div className="newsFeedCard-buttons-container">
                                                                    <Button type="button">
                                                                        <span className="readmore-button-text">{translate("link_readmore")}</span><ArrowForwardIosIcon className="readmore-arrow" />
                                                                    </Button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            }) : (
                                                <div className="noNewsFeed">{translate("dailyNewsFeed_noData")}</div>
                                            )
                                    }
                                </div>
                            </div>
                        </div>
                    )}
                </span>
            )}
        </span>
    );
}

export default DailyNewsFeedComponent;